<article class="block type-flex form-wizard" *ngIf="detail">
    <div class="row-small">
      <form class="form type-wizard" (submit)="saveDetail()" #heroForm="ngForm">

        <!-- GENERAL -->
        <fieldset class="wizard-chapter is--active">
          <legend class="form-title">General</legend>
          <app-detail-form-inline
            [detail]="detail"
            [materials]="fields.materials"
            [elements]="fields.detailCategories"
            [structures]="fields.detailStructures"
            (onSave)="saveDetail($event)"
            (onCancel)="handleCancel()">
          </app-detail-form-inline>
        </fieldset>
      </form>
  </div>
</article>
